import { Checklist } from "@/inspection/shared/dtos/Checklist";

export class ChecklistModel {
  public static from(checklist: Checklist) {
    return new ChecklistModel(checklist.id, checklist.type);
  }

  private constructor(public id: number, public type: string) {}
}
